<template>

<b-container>
  <b-alert
    :show="dismissCountDown"
    dismissible
    variant="success"
    @dismissed="dismissCountDown=0"
    @dismiss-count-down="countDownChanged"
  >
    <p>{{ alertcontent }}</p>
    <b-progress
    variant="warning"
    :max="dismissSecs"
    :value="dismissCountDown"
    height="4px"
    ></b-progress>
  </b-alert>
  <!-- v-b-modal.modal-1 -->
  <b-col md="12" class="mt-3 mb-5 p-0">
    <div>
      <b-breadcrumb class="px-0" @click="gopath()"  :items="items"></b-breadcrumb>
    </div>

    <b-row class="my-5">
        <b-col cols="12" sm="6" class="py-2">
          <span class="inline-block"> <span class="font-24">Wait for review</span> <span class="text-dark-grey"> {{ record.length }} Records Found, Page {{currentPage }} of {{Math.ceil(totalRows/perPage)}}</span></span>
        </b-col>
        <b-col cols="12" sm="6" class="py-2">
          <b-row >
            <b-col cols="12" sm="8" class="text-right py-1 ">
              <b-input-group >
                <i class="fas fa-search"></i>
                <b-form-input :autofocus="true" v-model="filter" style="border-radius: 50px;padding-left:40px;width: 26%;" placeholder="Search subject">
                </b-form-input>
              </b-input-group>
            </b-col>
            <b-col v-if="user.userLevel == 50" cols="12" sm="4" class="tCenter py-1">
              <b-button  v-if="user.userLevel == 50" @click="openNav()" :class="{activefilter : isfilter }" id="Filters" class="Filters">
                <span class="white px-3">
                  <i class="fas fa-filter"></i> FILTERS 
                </span>
              </b-button>
            </b-col>
          </b-row>
        </b-col>
    </b-row>
    
    <!-- <span class="inline-block"> <span class="font-24">Wait for review</span> <span class="text-dark-grey"> {{ record.length }} Records Found, Page {{currentPage }} of {{Math.ceil(totalRows/perPage)}}</span></span>

    <b-button  v-if="user.userLevel == 50" @click="openNav()" :class="{activefilter : isfilter }" id="Filters" class="inline-block float-right Filters ml-4">
      <span class="white">
        <i class="fas fa-filter"></i> FILTERS 
      </span>
    </b-button>
    <b-input-group class="ml-4" style="max-width:300px;    float: right;">
      <i class="fas fa-search"></i>
      <b-form-input :autofocus="true" v-model="filter" style="border-radius: 50px;padding-left:40px;width: 26%;" placeholder="Search subject">
      </b-form-input>
    </b-input-group> -->
    <!-- <b-button v-if="user.userLevel == 0" @click="modaldepartments = !modaldepartments"  class="inline-block float-right"
    ><i class="fas fa-plus"></i> Create Ticket</b-button> -->
  </b-col>
  <b-table
    :busy="isBusy"
    :bordered="true"
    show-empty
    :hover="true"
    stacked="lg"
    :items="filterSererity"
    :fields="user.userLevel == 0 ? selectrecord : selectrecordMentor"
    :current-page="currentPage"
    :per-page="perPage"
    :filter="filter"
    :sort-by.sync="sortBy"
    :sort-desc.sync="sortDesc"
    :sort-direction="sortDirection"
    @filtered="onFiltered"
  >
    <div slot="table-busy" class="text-center text-danger my-2 loading">
      <b-spinner class="align-middle"></b-spinner>
      <strong>Loading...</strong>
    </div>
    <template slot="empty" slot-scope="scope" class="text-center">
      <div class="text-center">
        No ticket waiting for reviews
      </div>
      
    </template>
    <template slot="ticketNo"  slot-scope="row" >
      <div class="text-center" v-if="user.userLevel == 0">
        <i class="fas fa-users" v-if="row.item.mentorId" v-b-tooltip.hover v-b-tooltip.html :title="'Owner: '+user.name +' '+user.surname +'<br>Commentator: '+ row.item.mentorName+' '+row.item.mentorSurname"></i>
        <i class="fas fa-globe-asia" v-else v-b-tooltip.hover title="Public"></i>
        <span>{{row.item.ticketNo}}</span>
      </div>
      <div class="text-center" v-else>
        <i class="fas fa-users" 
              v-b-tooltip.html 
              :title="'Owner: '+ row.item.name+' '+row.item.surname + 
              '<br>Commentator: '+user.name +' '+user.surname" ></i>
        <!-- :title="'Owner: '+row.item.comments[0].name +' '+row.item.comments[0].surname +'<br>Commentator: '+ user.name+' '+user.surname" -->
        <span>{{row.item.ticketNo}} </span> 
      </div>
    </template>
   <template slot="severityStatus" style="text-align:center" slot-scope="row" v-if="user.userLevel > 0">
      <div>
        <span :class="{'text-back':row.item.severityStatus == 2 , 'text-orange':row.item.severityStatus == 3 , 'text-dange':row.item.severityStatus == 4}">
          {{ convertseverity(row.item.severityStatus)}}
        </span>
      </div>
    </template>
    <template slot="subject" slot-scope="row">
      <div :title="row.item.subject">
        <span v-if="user.userLevel == 50">{{row.item.subject | snippetmoreSmall}}</span>
        <span v-else>{{row.item.subject | snippetMore}}</span>
      </div>
    </template>
    <template slot="status" style="text-align:center" slot-scope="row">
      <!-- {{ row }}  -->
      <!-- <b-button class="CLOSED" v-if="row.item.status == 6">CLOSED</b-button>
      <b-button class="OPEN" v-if="row.item.status == 1">OPEN</b-button>
      <b-button class="ONHOLD" v-if="row.item.status == 3">ON HOLD</b-button>
      <b-button class="COMPANY-REPLY" v-if="row.item.status == 5">COMPANY-REPLY</b-button>
      <b-button class="ANSWERED" v-if="row.item.status == 2" >ANSWERED</b-button>
      <b-button class="inprocress" v-if="row.item.status == 4" >inprocress</b-button> -->
      <b-button class="CLOSED status-btn cr-defualt" v-if="row.item.status == 6" ><span class="font-14 css-btn">CLOSED</span></b-button>
      <b-button class="OPEN status-btn cr-defualt" v-if="row.item.status == 1" ><span class="font-14 css-btn">OPEN</span></b-button>
      <b-button class="ONHOLD status-btn cr-defualt" v-if="row.item.status == 3" ><span class="font-14 css-btn">ON HOLD</span></b-button>
      <b-button class="COMPANY-REPLY status-btn cr-defualt" v-if="row.item.status == 5"><span class="font-14 css-btn">COMPANY-REPLY</span></b-button>
      <b-button class="ANSWERED status-btn cr-defualt"  v-if="row.item.status == 2"><span class="font-14 css-btn">ANSWERED</span></b-button>
      <b-button class="inprocress status-btn cr-defualt"  v-if="row.item.status == 4"><span class="font-14 css-btn">IN-PROCESS</span></b-button>
    </template>
    <template slot="category" slot-scope="row">
      <span style="width: 97px; display: block;">{{checkNameCategory(row.item.category)}}</span>
    </template>
    <template slot="createDate" slot-scope="row">
      <span style="width: 97px; display: block;">{{covertime(row.item.createDate)}}</span>
    </template>
    <template slot="updateDate" slot-scope="row">
      <span style="width: 97px; display: block;">{{covertime(row.item.updateDate)}}</span>
    </template>
    <template slot="isclose" slot-scope="row">
      <a  @click="changerouter(row.item)"><h6  class="hoverblue">View</h6></a>
    </template>
    <template slot="actions" slot-scope="row">
      <b-button size="sm" @click="info(row.item, row.index, $event.target)" class="mr-1">
      Info modal
      </b-button>
      <b-button size="sm" @click="row.toggleDetails">
      {{ row.detailsShowing ? 'Hide' : 'Show' }} Details
      </b-button>
    </template>
    <template slot="row-details" slot-scope="row">
      <b-card>
      <ul>
        <li v-for="(value, key) in row.item" :key="key">{{ key }}: {{ value }}</li>
      </ul>
      </b-card>
    </template>
  </b-table>
  <b-row class="mb-5">
    <b-col md="6" class="my-1" v-if="totalRows > 10">
      <b-pagination
        v-model="currentPage"
        :total-rows="totalRows"
        :per-page="perPage"
        class="my-0"
      ></b-pagination>
    </b-col>
  </b-row>
    <!-- Info modal -->
  <b-modal  :id="infoModal.id" :title="infoModal.title" ok-only @hide="resetInfoModal">
    <pre>{{ infoModal.content }}</pre>
  </b-modal>
    <!-- new Service -->
  <b-modal v-model="modalservice" hide-header hide-footer id="modal-1" size="lg">
    <b-container>
    <div class="d-flex justify-content-between mt-4" style="position:relative">
      <span @click="backcategory" style="color:#C4C4C4;cursor:pointer" class="back-to-cat"><i class="fas fa-chevron-left"></i> Back to category</span>
      <h2 class="abcenter"><strong>Choose category</strong></h2>
      <i @click="modalservice = !modalservice" class="fas fa-times"></i>
    </div>
    <h6  class="mt-4" v-if="typeof user.mentorDetail != 'undefined'"><strong>Mentor </strong>{{user.mentorDetail.detailUser[0].name}} {{user.mentorDetail.detailUser[0].surname}}</h6>
    <h6  class="mt-2"><strong>Category </strong>{{checkNameCategory(category_select)}}</h6>
        <!-- <h5 class="float-left">New Service Request  </h5>    <b-badge class="float-left" pill variant="primary"></b-badge> -->
    <h6 class="mb-1 mt-3"><strong>Subject</strong> </h6>
    <b-form-input v-model="newservice.topic" placeholder="Type Topic"></b-form-input>
    <b-row>
      <b-col md="6">
        <h6 class="mb-1 mt-3"><strong>Type of business:</strong>   </h6>
        <b-form-select v-model="newservice.selectinvesting" :options="typeOfBusiness"></b-form-select>
      </b-col>
      <b-col md="6">
        <h6 class="mb-1 mt-3"><strong> Severity :</strong> </h6>
          <b-form-select v-model="newservice.selectedSeverity" :options="optionseverity"></b-form-select>
      </b-col>
    </b-row>
      <h6 class="mb-1 mt-3"><strong>Details :</strong> </h6>
      <b-form-textarea
      id="textarea"
      v-model="newservice.detail"
      placeholder="Enter something..."
      rows="6"
      max-rows="6"
      ></b-form-textarea>
      <h6 class="mb-1 mt-3"><strong>Attachment</strong> 
        <span class="grey">(Allow File Extensions: .jpg, .gif, .jpeg, .png)</span> 
      </h6>
      <b-form-file
      v-model="newservice.file"
      :state="Boolean(newservice.file)"
      placeholder="Choose a file..."
      drop-placeholder="Drop file here..."
      ></b-form-file>
      <label class="orange"><font-awesome-icon icon="plus-circle"  /> Add More </label>
      <div class="mt-2 d-flex justify-content-center">
        <b-button @click="uploadfile_post" class="pr-5 pl-5">CREATE TICKET</b-button>
      </div>
    </b-container>
  </b-modal>
      <b-modal hide-header hide-footer  v-model="modaldepartments" size="lg" id="modal-xl2" v-if="user.userLevel == 0"  title="Choose category">
        <b-container>
          <h3 class="text-center" > <strong>Choose category</strong></h3>
          <h6  class="mt-4" v-if="typeof user.mentorDetail != 'undefined'"><strong>Mentor </strong>{{user.mentorDetail.detailUser[0].name}} {{user.mentorDetail.detailUser[0].surname}}</h6>
            <b-row class="mt-4">
          <b-col @click="adddepartment(val)" style="cursor:pointer" v-for="val in departmentsmock" :key="val.id" cols="12" sm="6"  md="6">
            <div v-if="typeof user.mentorDetail == 'undefined'">
              <b-card class="mb-3" >
                <b-card-text>
                <h6 class="mb-0"> {{ val.value }}</h6>
                <!-- <small>{{val.value}}</small> -->
                </b-card-text>
              </b-card>
            </div>
            <div v-else v-for="data in user.mentorDetail.detailUser[0].industryExpertise" >
              <b-card class="mb-3" v-if="data.name == val.value">
                <b-card-text>
                <h6 class="mb-0"> {{ val.value }}</h6>
                <!-- <small>{{val.value}}</small> -->
                </b-card-text>
              </b-card>
            </div>
            
          
            </b-col>
          </b-row>
        </b-container>
      </b-modal>
       <b-modal hide-header hide-footer  v-model="modaladdticket_success" size="lg" id="modal-success"   title="Choose category">
        <b-container>
          <i style="font-size:3rem" class="fas fa-check-circle mt-4 blue"></i>
          <h3 class="mt-4 blue">Your ticket has been successfully created</h3>
          <h5 class="mt-4"><strong>Ticket number</strong>  </h5>
          <b-button @click="modaladdticket_success = !modaladdticket_success" class="pr-5 pl-5 mt-5"
           >VIEW TICKET</b-button>
        </b-container>
      </b-modal>
      <vue-element-loading :active="loading" :is-full-screen="true"/>
    <div id="mySidenav" :class="{activesidenav : isfilter}" class="sidenav">
      <div id="closesidebar">
        <a  class="closebtn" @click="closeNav()">&times;</a>
          <!-- <a>Filters</a> -->
          <div style="position:relative">
          <a>SEVERITY</a>
          <hr/>
        </div>
          <b-form-checkbox
            v-for="(data,index) in optionseverity" :key="index"
              v-model="SEVERITY"
              :value="data.value"
          >
            {{data.text}}
          </b-form-checkbox>
                  
          <div style="position:relative" class="mt-4">
            <a>STATUS TICKET</a>
            <hr/>
          </div>

          <b-form-checkbox
            v-model="Statusticket"
            :value="1"
          >
          Open
          </b-form-checkbox>
          <b-form-checkbox
            v-model="Statusticket"
            :value="2"
          >
            <!-- unchecked-value="not_accepted" -->
          Answered
          </b-form-checkbox>
              <b-form-checkbox
            v-model="Statusticket"
            :value="4"
          >
          In process
          </b-form-checkbox>
              <b-form-checkbox
            v-model="Statusticket"
            :value="5"
          >
          Company-reply
          </b-form-checkbox>
            <b-form-checkbox
            v-model="Statusticket"
            :value="3"
          >
          On hold
          </b-form-checkbox>
                  <b-form-checkbox
            v-model="Statusticket"
            :value="6"
          >
          Closed
          </b-form-checkbox>

          <div style="position:relative" class="mt-4">
                  <a>CATEGORY </a>
                  <hr/>
          </div>
          <b-form-checkbox
            v-model="CATEGORY"
            :value="index"
            v-for="(item, index) in departmentsmocklimit" :key="index"
            >
          {{item.value}}
          </b-form-checkbox>
          <div class="mt-2 mb-2" >
            <span v-if="departmentsmock.length != departmentsmocklimit.length" class="blue" @click="MoreCat()">More</span>
          </div>
          <div class="py-2 mb-5 tCenter">
            <b-button @click="SEVERITY = [],Statusticket=[],CATEGORY=[]"  class="clearfilter" >
              CLEAR ALL FILTERS
            </b-button>
          </div>
      </div>
    </div>
   </b-container >
</template>
<script>
import Swal from 'sweetalert2'
import moment from "moment";
import { mapState } from "vuex";
import {HTTPTICKET,HTTPMentor,HTTPDynamic} from "@/axios";
import axios from "axios";
import router from '../router'
export default {
  name: 'HelloWorld',
  data () {
    return {
      items: [
          {
            text: 'Tickets',
            active: true,
            class:'cr-pointer',
            
          },
          {
            text:'Wait for review',
            disabled:true
          },
      ],
      isBusy:false,
      isfilter:false, 
      SEVERITY:[],
      Statusticket:[],
      CATEGORY:[],
      allCategory:[],
      departmentsmock:[],
       modaldepartments:false,
       dismissSecs: 10,
        dismissCountDown: 0,
        loading:false,
        text:null,
        record:[],
        selectrecord:[
          { key: 'ticketNo', label: 'Ticket No.', sortable: true, class: 'text-center align-middle arrow' },
          { key: 'subject', label: 'Subject', sortable: true, sortDirection: 'desc',class:'align-middle arrow' },
          { key: 'status', label: 'Status', class:'status align-middle arrow' },
          { key: 'category', label: 'Category',class:'align-middle' },
          { key: 'createDate', label: 'Created date', sortable: true,class:'align-middle arrow' },
          { key: 'updateDate', label: 'Last Updated', sortable: true,class:'align-middle arrow' },
          { key: 'isclose', label: '',class:'view align-middle arrow' },
        ],
        selectrecordMentor:[
          { key: 'ticketNo', label: 'Ticket No.', sortable: true, class: 'text-center align-middle arrow' },
          { key: 'severityStatus', label: 'Severity', sortable: true, sortDirection: 'desc',class:'align-middle arrow text-center' },
          { key: 'subject', label: 'Subject', sortable: true, sortDirection: 'desc',class:'align-middle arrow' },
          { key: 'status', label: 'Status', class:'status align-middle'},
          { key: 'category', label: 'Category',class:'align-middle arrow' },
          { key: 'createDate', label: 'Created date', sortable: true, class:'align-middle arrow'},
          { key: 'updateDate', label: 'Last Updated', sortable: true, class:'align-middle arrow'},
          { key: 'isclose', label: '',class:'view arrow align-middle' },
        ],
        form: {
          email: '',
          name: '',
          food: null,
          checked: []
        },
        totalRows: 1,
        currentPage: 1,
        perPage: 10,
        optionsinvesting:[],
        optionseverity:[
          { value: 1, text: 'Low' },
          { value: 2, text: 'Modarate' },
          { value: 3, text: 'High' },
          { value: 4, text: 'Critical' },
        ],
         options: [
          { value: null, text: 'Please select an option' },
          { value: 'a', text: 'This is First option' },
          { value: 'b', text: 'Selected Option' },
          { value: { C: '3PO' }, text: 'This is an option with object value' },
          { value: 'd', text: 'This one is disabled', disabled: true }
        ],
        selected:null,
        pageOptions: [5, 10, 15],
        sortBy: null,
        sortDesc: false,
        sortDirection: 'asc',
        filter: null,
        infoModal: {
          id: 'info-modal',
          title: '',
        content: '',
        },
        newservice:{
          selectinvesting:'Food for the future',
          topic:'',
          detail:'',
          selectedSeverity:0,
          file:null,
          uploadfilesuccess:[{
                      fileName:null
                    }],
        },
        interestedinvesting:[],
        modalservice:false,
        modaladdticket_success:false,
        alertcontent:'',
        category_select:'',
        limitCat:5,
      }
  },
  created(){
  },
  mounted(){
    this.isBusy = true
    this.getallrecord()
    this.getAllCategory()
  },
    computed: {
       ...mapState(["user","typeOfBusiness"]),
      sortOptions() {
        return this.fields
          .filter(f => f.sortable)
          .map(f => {
            return { text: f.label, value: f.key }
          })
      },
      user(){
        return this.$store.state.user
      },
      loginalready(){
        return this.$store.state.user.loginalready
      },
      token(){
        return this.$store.state.token
      },
      departmentsmocklimit(){
        return this.departmentsmock.slice(0,this.limitCat)
      },
      filterCateGory(){
        if(typeof this.CATEGORY !=='undefined' && this.CATEGORY.length > 0){
          let allCat =[]
          this.record.map(item =>{
            this.CATEGORY.filter(data =>{
            if(data == item.category){
              allCat.push(item)
              }
            })
          })
          return allCat
        }else{
          return this.record  
        }
      },  
      filterStatus(){
        if(typeof this.Statusticket !='undefined' && this.Statusticket.length > 0){
          let allCat =[]
          this.filterCateGory.map(item =>{
            this.Statusticket.filter(data =>{
            if(data == item.status){
              allCat.push(item)
              }
            })
          })
          return allCat
        }else{
          return this.filterCateGory
        }
      },
      filterSererity(){
        if(typeof this.SEVERITY !='undefined' && this.SEVERITY.length > 0){
          let allCat =[]
          this.filterStatus.map(item =>{
            this.SEVERITY.filter(data =>{
            if(data == item.severityStatus){
              allCat.push(item)
              }
            })
          })
          return allCat
        }else{
          return this.filterStatus
        }
      },
    },
    methods:{
      gopath(){
        this.$router.go('-1')
      },
       MoreCat(){
          this.limitCat += 5;
        },
      checkNameCategory(value){
          let data =  this.departmentsmock.filter(search =>{
            return search.index == value
          })
          if(data.length > 0){
            return data[0].value
          }else{
            return ''
          }
      },
      getAllCategory(){
        HTTPTICKET.post('/api/get/all/category').then(res=>{
          if(res.data.success){
            res.data.obj.map(val =>{
              this.departmentsmock.push({value:val.name,index:val.index})
            })
            console.log('/api/get/all/category',this.departmentsmock)
          }
        })
      },
      getTypeOfBusiness(){
        HTTPTICKET.post('/api/get/type/of/business').then(res=>{
          let data = []
          if(res.data.success){
            res.data.obj.map(val =>{
              data.push({value:val.index,text:val.name})
              this.$store.commit('setTypeOfBusiness',data)
            })
          }
        })
      },
      openNav(){
        if(this.isfilter){
          this.$store.commit('profilemenumargin',false)
          this.isfilter = false
        }else{
           this.$store.commit('profilemenumargin',true)
          this.isfilter = true
        }
      },
      closeNav(){
          this.$store.commit('profilemenumargin',false)
          this.isfilter = false
      },
      backcategory(){
        this.modaldepartments = true
        this.modalservice = false
      },
      errorcatch(){
        Swal.fire(
        'Error',
        'Please check your network connection',
        'error'
        )
      },
      adddepartment(val){
        this.category_select = val.index
        this.modaldepartments = false
        this.modalservice = true
      },
      covertime(value){
        // console.log(value)
        if (value) {
            var t = moment(value).format("DD MMMM YYYY h:mm a")
            return t;
          }
      },
      showAlert(val) {
        this.dismissCountDown = this.dismissSecs
        this.alertcontent = val
      },
      countDownChanged(dismissCountDown) {
        this.dismissCountDown = dismissCountDown
      },
      uploadfile_post(){
        this.loading = true
         let formData = new FormData();
          formData.append('file', this.newservice.file);
          console.log(this.newservice.file)
           if(this.newservice.file == null){
            // alert('123')
            this.submitpost()
            return
          }
          // return
          
          HTTPTICKET.defaults.headers.common.Authorization = `Bearer ${this.user.token}`;
          HTTPTICKET.post(`/upload/ticket`,formData)
          .then(res => {
            console.log(res.data)
              if (res.data.success) {
               this.newservice.uploadfilesuccess[0].fileName = res.data.obj
               this.submitpost()
              }
          })
          .catch(e => {  
            this.errorcatch()
            this.loading = false
            console.log("upload/postFile",e);
          });
      },
      submitpost(){
        var data= {
          category:this.category_select,
          industry:this.newservice.selectinvesting,
          subject:this.newservice.topic,
          mentorId:this.user.mentorDetail != null && typeof this.user.mentorDetail != 'undefined' ? this.user.mentorDetail.userId : '',
          // ownedBy:this.user.userId,
          detail:this.newservice.detail,
          status:1,
          severityStatus:this.newservice.selectedSeverity,
          postFile:this.newservice.uploadfilesuccess
        } 
        console.log('created',data)
        HTTPTICKET.defaults.headers.common.Authorization = `Bearer ${this.user.token}`;
        HTTPTICKET.post(`/api/create/ticket`,data).then(res => {
          this.loading=false
          if (res.data.success) {
            // this.showAlert("Add New Service Request Success")
            this.modaladdticket_success = true
            this.modalservice = false
            this.newservice = {}
            this.getallrecord()
          }
        })
        .catch(e => {  
          this.errorcatch()
          this.loading = false
            console.log("/api/create/ticket",e);
        });
      },
      getallrecord(){
        let data = {
            userId:this.user.userId,
            userLevel:this.user.userLevel,
            ticket:''
        }
        console.log(data)
        HTTPTICKET.defaults.headers.common.Authorization = `Bearer ${this.user.token}`;
        HTTPTICKET.post('/api/company/get/ticket/not/review',data).then(res => {
          console.log('/api/company/get/ticket/not/review',res)
          if (res.data.success) {
          let addindex = res.data.obj.map((x,index) =>{
            var data = {
              index: index+1,
              ...x,
            }
            return data
          })
          addindex.sort((a, b) => {
            const modifier = -1;
            if (new Date(a.updateDate) < new Date(b.updateDate)) return -1 * modifier;
            if (new Date(a.updateDate) > new Date(b.updateDate)) return 1 * modifier;
            return 0;
          });
           this.record = addindex
           this.totalRows = this.record.length
           console.log('this.record',this.record)
           this.isBusy = false
          }else{}
          setTimeout(()=>{
            this.isBusy = false
          },7000)
        })
        .catch(e => {
          this.errorcatch()
            console.log("/api/company/get/ticket/not/review",e);
             this.isBusy = false
        })
      }, 
      changerouter(val){
        this.$router.push('/detail/'+val._id);
      },
      info(item, index, button) {
        this.infoModal.title = `Row index: ${index}`
        this.infoModal.content = JSON.stringify(item, null, 2)
        this.$root.$emit('bv::show::modal', this.infoModal.id, button)
      },
      resetInfoModal() {
        this.infoModal.title = ''
        this.infoModal.content = ''
      },
      onFiltered(filteredItems) {
        this.totalRows = filteredItems.length
        this.currentPage = 1
      },
      fetchdatainvest(){
          let data ={
            keyRequest:this.token
          }
          HTTPDynamic.defaults.headers.common.Authorization = `Bearer ${this.token}`;
          HTTPDynamic.post(`api/get/form`,data).then(res => {
          console.log('api/get/form',res.data)
          if (res.data.success) {
            this.interestedinvesting = res.data.obj.form[1].component.components[0].componentData[5].display
            console.log(this.interestedinvesting)
            let mapoption = res.data.obj.form[1].component.components[0].componentData[5].display.value.map(val =>{
             var data =  { value: val.label , text: val.label }
             return data
            })
            this.optionsinvesting = mapoption
            this.getallrecord()
          }
        })
        .catch(e => {  
            this.errorcatch()
            console.log("api/get/form",e);
        });
        this.getallrecord()
      }
    },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
$filter :linear-gradient(180deg, #0D6ACA -34.44%, #0FB9F4 120%);
$grey :#C4C4C4;
$CLOSED: #E70000;
$OPEN: #0D6ACA;
$ONHOLD: #FD7900;
$COMPANY-REPLY: #0FB9F4;
$ANSWERED: #0ABA06;

@media only screen and (max-width: 576px) {
  .tCenter{
    text-align: center!important;
  }

}
.custom-control{
      min-height: 1.9rem;
}
.breadcrumb-item.active{
    cursor: pointer !important;
}
.breadcrumb{
    background-color: white !important;
}
.clearfilter{
  background: white;
  color: $ONHOLD;
  box-shadow: 0 0 0 1px $ONHOLD;
}
#Filters{
  background-image: $filter;
}

.blue{
  color:$COMPANY-REPLY;
}
.orange{
  color: $ONHOLD;
}
.grey{
  color: $grey
}
.abcenter{
  position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%,-50%)
}
#modal-xl2 .modal-body{
  padding: 2rem 5rem;
}
#modal-xl2 .card-body{
  padding: 0.85rem;
}
#modal-xl2 .card:hover{
  border-color: $COMPANY-REPLY;
  color: $COMPANY-REPLY;
}

.input-group{
  position: relative;
}

.fa-search{
      position: absolute;
    z-index: 20;
    color: #C4C4C4;
    left: 14px;
    top: 50%;
    transform: translateY(-50%);
}
.card-body{
  text-align: center;
}
.alert-success{
      position: relative;
    top: 30px;
}
.btn-outline-primary{
  border-radius: 30px;
}

.btn-secondary{
background-color: white;
    border-color: white;
    border-radius: 30px;
   
}
.CLOSED{
  border-color: $CLOSED;
  white-space: nowrap;
  background-image: linear-gradient($CLOSED, $CLOSED);
  padding: 0.25rem 2.5rem;
   border-radius: 34px;
   

}
.OPEN{
  border-color: $OPEN;
  background-image: linear-gradient($OPEN, $OPEN);
  padding: 0.25rem 2.5rem;
   border-radius: 34px;
   
    white-space: nowrap;
}
.ONHOLD{
   border-color: $ONHOLD;
  background-image: linear-gradient($ONHOLD, $ONHOLD);
  padding: 0.25rem 2.5rem;
   border-radius: 34px;
   
    white-space: nowrap;
}
.COMPANY-REPLY{
  border-color: $COMPANY-REPLY;
  background-image: linear-gradient($COMPANY-REPLY, $COMPANY-REPLY);
  padding: 0.25rem 2.5rem;
   border-radius: 34px;
   
    white-space: nowrap;
}
.ANSWERED{
    border-color: $ANSWERED;
  background-image: linear-gradient($ANSWERED, $ANSWERED);
  padding: 0.25rem 2.5rem;
   border-radius: 34px;
    white-space: nowrap;
}
//  border-color: $orange-top;
//     background-image: linear-gradient($orange-top, $orange-bottom);
//    border-color: $orange-top;
// menu 
/* menumenumenu */
#Filters.activefilter{
  border: 1px solid #0D6ACA !important;
  background: transparent !important;
}

#Filters.activefilter span,#Filters.activefilter i{
  color: #0D6ACA !important;
}
.sidenav {
      /* background: ; */
  box-shadow: -10px 0px 10px 1px rgba(0,0,0,0.15);
  z-index: 99;
  height: 100%;
  width: 0;
  position: fixed;
  top: 0;
  right: 0;
  background-color: white;
  overflow-x: hidden;
  transition: 0.5s;
  padding: 50px 20px 0 20px;
}

.sidenav a {
    // padding: 0 0 10px 0;
    text-decoration: none;
    font-size: 16px;
    font-weight: bold;
    color: black;
    display: block;
    transition: 0.3s;
    text-align: left;
}
.sidenav a.language{
  display: inline-block;
  width: 45%;
  word-break: break-word;
}
.sidenav a:hover {
 color: black;
}

.sidenav .closebtn {
  position: absolute;
  top: 0;
  right: 25px;
  font-size: 36px;
  margin-left: 50px;
}

#closesidebar{
  width: 0;
  padding: 0;
  opacity: 0;
  margin-left: 0;
}
#mySidenav{
  position:fixed;
  width:400px;
  right:-500px;
  transition: all 0.4s;
  --webkit-transition: all 0.4s;
  padding:50px 20px 0 20px;
}
#mySidenav.activesidenav{
  right:0px;
}
.activesidenav #closesidebar{
  width:400px;
  opacity:1;
 transition: 0.5s
}
// menu
@media only screen and (max-width: 403px) {
  #mySidenav.activesidenav,.activesidenav #closesidebar{
  width:100vw;
  left: 0
}
}

@media screen and (max-height: 450px) {
  .sidenav {padding-top: 15px;}
  .sidenav a {font-size: 18px;}
}
.status-btn{
  width: 75%;
  height: 30px
}
.css-btn{
  display: flex; 
  align-items: center; 
  justify-content: center; 
  color: white;
  font-weight: 400;
}
</style>



// WEBPACK FOOTER //
// src/components/ReviewComment.vue